import styled from 'styled-components';

export const AboutPage = styled.div`
  background: #efefef;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1100px;
  padding-top: 80px;

  @media screen and (max-width: 768px) {
    padding: 80px 20px 0;
  }
`;

export const AboutHeader = styled.span`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 50px;
`;

export const AboutText = styled.div`
  font-size: 1.2rem;
  margin-bottom: 50px;
  text-align: left;
  max-width: 900px;

  p {
    margin-bottom: 20px;
    line-height: 1.6;
  }
`;

export const AboutList = styled.ul`
  list-style-type: disc;
  margin: -10px 0 20px 30px;
  text-align: left;
`;

export const AboutListItem = styled.li`
  font-size: 1.2rem;
  margin-bottom: 8px;
  line-height: 1.5;
`;
